import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import {
  PropType,
  computed,


  onBeforeMount,
  ref
} from 'vue';
import { useI18n } from 'vue-i18n';
import { BaseTextarea } from '@/lib/components/Textarea';
import { IValidationError } from '@/lib';
import { ReasonsService } from '@/services/api';
import { ReasonsGroupType } from '@/constants';
import { MedKitSelect, SelectionOption } from '@bigpicturemedical/medkit';

import { ReasonValue, REASON_MAX_LENGTH } from '@/models';
import axios from 'axios';


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseSelectReason',
  props: {
  modelValue: {
    type: Object as PropType<ReasonValue>,
    default: () => ({
      selectedReason: '',
      additionalReason: '',
      hideTextArea: false
    })
  },
  mandatoryReasonsList: {
    type: Array as PropType<Array<string> | undefined>,
    default: () => []
  },
  error: {
    type: String,
    default: ''
  },
  mode: {
    type: String as PropType<ReasonsGroupType>,
    required: true
  },
  hideTextArea: {
    type: Boolean,
    required: false
  }
},
  emits: ["update-error-limit-char", "update:modelValue", "select-reason"],
  setup(__props, { emit: __emit }) {

const { t } = useI18n();
const props = __props;
// TODO: please add emits values definition
const emit =
  __emit;

const showAdditional = ref(false);
const maxCharAdditionalInfo = ref(500);
const reasonsOptions = ref<SelectionOption[]>([]);
const reasonMaxLength: number = REASON_MAX_LENGTH;
const reasonService = new ReasonsService(props.mode);
const fetchErrors = ref<IValidationError | null>(null);

const isReasonMandatory = computed(() => {
  let status = false;
  if (props.mandatoryReasonsList.length > 0) {
    status = !!props.mandatoryReasonsList.includes(
      props.modelValue.selectedReason
    );
  }

  props.modelValue.selectedReason !== '' &&
    !showAdditional.value &&
    toggleAdditional();
  return status;
});

onBeforeMount(async () => {
  await fetchReasonsOptions();
});

const fetchReasonsOptions = async () => {
  try {
    const response = await reasonService.getOptions();
    const list: string[] = response.data
      ? response.data
      : (response as unknown as string[]);

    list.map((item) => {
      reasonsOptions.value.push({
        label: t(`custom.uhb.consult.${props.mode}-reasons.${item}`),
        value: item
      });
    });
  } catch (e) {
    if (!axios.isAxiosError(e)) {
      throw e;
    }
    if (e.response?.status === 422) {
      fetchErrors.value = e.response.data?.errors;
    } else {
      fetchErrors.value = {
        message: e.response?.data?.message || '',
        errors: {}
      };
    }
  }
};
const updateSelect = (event) => {
  setReason({ selectedReason: event });
};
const toggleAdditional = () => (showAdditional.value = !showAdditional.value);
const setReason = (value: Partial<ReasonValue>) => {
  const updated = { ...props.modelValue, ...value };
  maxCharAdditionalInfo.value = 500 - updated.additionalReason.length;
  emit('update-error-limit-char', maxCharAdditionalInfo.value);
  emit('update:modelValue', { ...updated });
  emit('select-reason', { ...updated });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(MedKitSelect), {
      label: _ctx.$t(`custom.uhb.consult.primary-${__props.mode}-reason`),
      options: reasonsOptions.value,
      placeholder: _unref(t)('custom.uhb.consult.select-reason'),
      "model-value": __props.modelValue.selectedReason,
      error: __props.error || undefined,
      "data-dusk": `${__props.mode}-reason-type-select`,
      required: "",
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (updateSelect($event)))
    }, null, 8, ["label", "options", "placeholder", "model-value", "error", "data-dusk"]),
    ((showAdditional.value || isReasonMandatory.value) && !__props.hideTextArea)
      ? (_openBlock(), _createBlock(_unref(BaseTextarea), {
          key: 0,
          "model-value": __props.modelValue.additionalReason,
          label: _ctx.$t('custom.uhb.consult.additional-information'),
          "is-optional": !isReasonMandatory.value,
          "data-dusk": `${__props.mode}-reason-text`,
          rows: 3,
          "max-length": _unref(reasonMaxLength),
          instructions: 
        _ctx.$t('platform.instructions.maximum-characters', [
          __props.modelValue.additionalReason.length,
          _unref(reasonMaxLength)
        ])
      ,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (setReason({ additionalReason: $event })))
        }, null, 8, ["model-value", "label", "is-optional", "data-dusk", "max-length", "instructions"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})